module.exports = __webpack_public_path__ + "img/tkl.1959d9de.svg";